module.exports = __webpack_public_path__ + "static/media/bry-r.bc298faa.mp3";